export default Object.freeze({
  SIGNIN: 'SIGNIN',
  SIGNUP: 'SIGNUP',
  PASSWORD: 'PASSWORD',
  PROFIL: 'PROFIL',
});
